import { Component } from '@angular/core';
import { getDocumentNumber, mongoId } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { CompilationModel } from '../../../../@models/erp/compilation';
import { CompilationTypeData, DocumentStatusData, UnitData } from '../../../../@models/erp/compilationData';
import { DocumentSelectComponent } from './document-select.component';


@Component({
  selector: 'ngx-document-in-selector',
  templateUrl: '../document-select/document-select.component.html',
  styleUrls: ['../document-select/document-select.component.scss'],
})
export class DocumentInSelectorComponent extends DocumentSelectComponent {

  constructor(public api: ApiService, public data: SharedDataService) {
    super(data);
  }

  // preFilter(items: CompilationModel[]): CompilationModel[] {
  //   const res = [];
  //   for (const item of items) {
  //     item.lineItems.forEach((li, idx) => { // unwind lineItems
  //       const copy = Object.assign({
  //         productCode: this.data.finishedProducts.find(f => mongoId(f) === mongoId(li.finishedProduct))?.calcCode,
  //         productName: this.data.getFinishedProductString(li.finishedProduct),
  //         liQuantity: li.quantity,
  //         liUnit: li.displayUnit,
  //         ocPos: idx+1,
  //         assignedQ: li.pfspo?.length && li.pfspo[idx]?.quantity,
  //       }, item);
  //       res.push(copy);
  //     })
  //   }
  //   // console.log('res', res.length);
  //   return res.filter(f => f.draft || f.documentStatus === DocumentStatusData.get('final').id);
  // }
  
  async ngOnInit() {
    this.initialItems = this.preFilter(
      (await this.api.getAllVersionData(
        false,
        true,
        [
          'code', 'version', 'draft', 'documentStatus', 'nameOverride', 'issueDate',
          'completelyInvoiced', 'recipient', 'accountManager', 'customerName', 'customerDocumentNumber', 'customerDocumentDate'
        ],
        '^(INNRK)',
      )) as CompilationModel[]
    );
    this.latestVersionItems = [...this.initialItems];
    this.onFilter();
    console.log('selector latest version items', this.latestVersionItems, this.initialItems);
  }

  columns = [
    { id: 'completelyInvoiced', title: 'INV', search: '' },
    { id: 'code', title: 'Document number', search: '' },
    { id: 'issueDate', title: 'Issue Date', search: '' },
    { id: 'recipient', title: 'Recipient', search: '' },
    // { id: 'customerName', title: 'Customer', search: '' },
    { id: 'customerDocumentNumber', title: 'Customer Doc #', search: '' },
    { id: 'customerDocumentDate', title: 'Customer Doc Date', search: '' },

    // { id: 'ocPos', title: 'OC Pos', search: '', type: 'number' },
    // { id: 'productCode', title: 'Product Code', search: '' },
    // { id: 'productName', title: 'Product Name', search: '' },
    // { id: 'liQuantity', title: 'Q', search: '', type: 'number' },
    // { id: 'liUnit', title: 'Unit', search: '' },
    // { id: 'vieDispatchDate', title: 'Dispatch date', search: '' },
    // { id: 'etaCustomerDate', title: 'ETA Customer', search: '' },
    // { id: 'customerRequestedDeliveryDate', title: 'CRDD', search: '' },
    // { id: 'customerAcceptedDeliveryDate', title: 'CADD', search: '' },
    // { id: 'assignedQ', title: 'Assigned Q', search: '', type: 'number' },
  ]

  getText(col: string, item: CompilationModel) {
    if (!item) return '';
    switch (col) {
      case 'completelyInvoiced': return item[col] ? '✓' : '';
      case 'code': return getDocumentNumber(item);
      case 'recipient': return item[col]?.name;
      case 'issueDate':
      case 'customerDocumentDate':
      // case 'vieDispatchDate':
      // case 'etaCustomerDate':
      // case 'customerRequestedDeliveryDate':
      // case 'customerAcceptedDeliveryDate':
        return (item[col] as any)?.replace(/T.*/, '');
      default: return item[col];
    }
  }


}

